import React, { useEffect } from "react";

import UpdateTestModal from "./Modal/UpdateTestModal";
import TestListRow from "./TestListRow";

import { useDispatch, useSelector } from "react-redux";
import Overlay from "../../../../../SharedComponents/Overlay";
import { getTests } from "../../Store/Thunk";

export default function TestList({ isArchiveActive }) {
  const dispatch = useDispatch();
  const tests = useSelector((state) => state.test.tests);

  const isLoading = useSelector((state) => state.test.isLoading);

  useEffect(() => {
    dispatch(getTests());
  }, []);

  return (
    <>
      {isLoading && <Overlay />}
      {tests?.length > 0 &&
        tests.map((test, i) => {
          let editedTest = { ...test };
          editedTest.isTest = true;
          if (editedTest.isArchive === isArchiveActive) {
            return <TestListRow test={editedTest} key={i} />;
          }
        })}

      <UpdateTestModal />
    </>
  );
}
